import { blue, green, grey, purple, red } from '@mui/material/colors'
import maplibregl from 'maplibre-gl'
import hinanAreaJson from 'assets/hinan/hinanArea.json'

type LayerKey = 'EF_SHINSUISOUTEI' | 'EF_SHINSUISOUTEI_COLOR' | 'EF_SHINSUILATEST' | 'SHINSUI_R06' |
  'CITY' | 'TOMOE' | 'HINAN_AREA_ALL' | 'RIVER' | 'SCHOOL_AREA_RISK' | 'SCHOOL_AREA_RISK_PURPLE' | 'SCHOOL_AREA_RISK_BLACK' | 'OBSERVATORY' | 'MOBILE_LOCATION'

export const LAYERS: Record<LayerKey, maplibregl.AddLayerObject> = {

  // 洪水浸水想定区域(灰色)
  EF_SHINSUISOUTEI: {
    id: 'ef_shinsuisoutei',
    type: 'raster',
    source: {
      type: 'image',
      url: 'https://d1zetlo8apprf7.cloudfront.net/hinan/png/shinsuisoutei.png',
      coordinates: [
        [138.38375, 35.045833333],
        [138.5009375, 35.045833333],
        [138.5009375, 34.950833333],
        [138.38375, 34.950833333]
      ]
    },
    minzoom: 10,
    maxzoom: 15,
    paint: {
      'raster-resampling': 'nearest',
      'raster-opacity': 0.5,
      'raster-fade-duration': 0,
    }
  },

  // 洪水浸水想定区域(色付き)
  EF_SHINSUISOUTEI_COLOR: {
    id: 'ef_shinsuisoutei_color',
    type: 'raster',
    source: {
      type: 'image',
      url: 'https://d1zetlo8apprf7.cloudfront.net/hinan/png/shinsuisoutei_color.png',
      coordinates: [
        [138.38375, 35.045833333],
        [138.5009375, 35.045833333],
        [138.5009375, 34.950833333],
        [138.38375, 34.950833333]
      ]
    },
    layout: {
      visibility: 'none'
    },
    minzoom: 10,
    maxzoom: 15,
    paint: {
      'raster-resampling': 'nearest',
      'raster-opacity': 0.6,
      'raster-fade-duration': 0,
    }
  },

  // 浸水推定システム - 浸水していると推定される範囲の浸水深
  EF_SHINSUILATEST: {
    id: 'ef_shinsuilatest',
    type: 'raster',
    source: {
      type: 'image',
      url: 'https://d1zetlo8apprf7.cloudfront.net/hinan/png/shinsui_latest.png',
      coordinates: [
        [138.35, 35.075],
        [138.525, 35.075],
        [138.525, 34.925],
        [138.35, 34.925]
      ]
    },
    layout: {
      visibility: 'none'
    },
    minzoom: 10,
    maxzoom: 15,
    paint: {
      'raster-resampling': 'nearest',
      'raster-opacity': 0.8,
      'raster-fade-duration': 0,
    }
  },

  // 浸水実績R6T10
  SHINSUI_R06: {
    id: 'shinsui_r06',
    type: 'line',
    source: {
      type: 'geojson',
      data: 'https://d1zetlo8apprf7.cloudfront.net/static/ShinsuiR06.geojson'
    },
    layout: {
      visibility: 'none'
    },
    paint: {
      'line-color': red[500],
      'line-width': 3
    },
    minzoom: 8
  },

  // 静岡市アウトライン
  CITY: {
    id: 'city',
    type: 'line',
    source: {
      type: 'geojson',
      data: 'https://d1zetlo8apprf7.cloudfront.net/static/outline.geojson'
    },
    layout: {},
    paint: {
      'line-color': grey[900],
      'line-width': 2,
      'line-dasharray': [1, 2]
    },
    minzoom: 8
  },

  // 巴川流域
  TOMOE: {
    id: 'tomoe',
    type: 'line',
    source: {
      type: 'geojson',
      data: 'https://d1zetlo8apprf7.cloudfront.net/static/tomoe.geojson'
    },
    layout: {},
    paint: {
      'line-color': green[500],
      'line-width': 3
    },
    minzoom: 1
  },

  // 避難指示区域（水色破線）
  HINAN_AREA_ALL: {
    id: 'school_area_all',
    type: 'line',
    source: {
      type: 'geojson',
      data: hinanAreaJson as GeoJSON.FeatureCollection
    },
    layout: {},
    paint: {
      'line-color': blue[500],
      'line-width': 3,
      'line-dasharray': [1, 2]
    },
    minzoom: 8
  },

  // 河川
  RIVER: {
    id: 'river',
    type: 'line',
    source: {
      type: 'geojson',
      data: 'https://d1zetlo8apprf7.cloudfront.net/static/river.geojson'
    },
    layout: {},
    paint: {
      'line-color': '#0000ff',
      'line-width': 3
    },
    minzoom: 8
  },

  // 避難対象地区（赤線）
  SCHOOL_AREA_RISK: {
    id: 'school_area_risk',
    type: 'line',
    source: {
      type: 'geojson',
      data: hinanAreaJson as GeoJSON.FeatureCollection
    },
    paint: {
      'line-color': red[500],
      'line-width': 3,
    },
    filter: ['any', ['==', ['get', 'name'], 'dammy']]
  },

  // 避難対象地区（紫線）
  SCHOOL_AREA_RISK_PURPLE: {
    id: 'school_area_risk_purple',
    type: 'line',
    source: {
      type: 'geojson',
      data: hinanAreaJson as GeoJSON.FeatureCollection
    },
    paint: {
      'line-color': purple[500],
      'line-width': 4,
      'line-offset': 3
    },
    filter: ['any', ['==', ['get', 'name'], 'dammy']]
  },

  // 避難対象地区（黒線）
  SCHOOL_AREA_RISK_BLACK: {
    id: 'school_area_risk_black',
    type: 'line',
    source: {
      type: 'geojson',
      data: hinanAreaJson as GeoJSON.FeatureCollection
    },
    paint: {
      'line-color': grey[900],
      'line-width': 4,
      'line-offset': 3
    },
    filter: ['any', ['==', ['get', 'name'], 'dammy']]
  },

  // 観測所
  OBSERVATORY: {
    id: 'observatory',
    type: 'symbol',
    source: {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: []
      },
      cluster: false,
      clusterMaxZoom: 1,
      clusterRadius: 1
    },
    layout: {
      'icon-image': ['get', 'icon'],
      'icon-size': 0.5,
      'icon-allow-overlap': true,
      'text-allow-overlap': false,
      'text-field': ['get', 'name'],
      'icon-offset': ['get', 'offset'],
      'text-optional': true,
      'text-justify': 'left',
      'text-size': 11,
      'text-offset': [0, 2],
      'symbol-z-order': 'source'
    },
    paint: {
      'text-color': 'black'
    }
  },

  // モバイル登録位置
  MOBILE_LOCATION: {
    id: 'mobile_location',
    type: 'symbol',
    source: {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: []
      }
    },
    layout: {
      'visibility': 'none',
      'icon-image': ['get', 'icon'],
      'icon-size': 0.5,
      'icon-allow-overlap': true,
      'text-allow-overlap': false,
      'text-field': ['get', 'name'],
      'text-optional': true,
      'text-justify': 'left',
      'text-size': 11,
      'text-offset': [0, 2],
      'symbol-z-order': 'source'
    }
  },
}
